import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { Subject } from 'rxjs';

import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-monthly-provisional-report',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    NgbDropdownModule,
    LoaderComponent
  ],
  templateUrl: './monthly-provisional-report.component.html',
  styleUrl: './monthly-provisional-report.component.scss'
})
export class MonthlyProvisionalReportComponent implements OnInit, OnDestroy {

  isDisabled = false;

  TableDatas: any[] = [];
  Branchs = null as any;
  FinancialYears: any[] = [];

  dtTrigger: Subject<any> = new Subject<any>();

  Detail = {
    SelectType: 'Monthly Provisional Report',
    TaxBasedon: '',
    TaxMonth: '',
    EmpmasterID: 0,
    EmpType: '',
    FinancialYear: null as any,
    BranchID: null as any,
    Quarter: null as any,
    SiteIDs: '',
    Empcode: '',
    UserID: 0
  };

  Quarters = [
    { Quarter: 'All', QuarterValue: 'All' },
    { Quarter: 'Q1', QuarterValue: 'Q1' },
    { Quarter: 'Q2', QuarterValue: 'Q2' },
    { Quarter: 'Q3', QuarterValue: 'Q3' },
    { Quarter: 'Q4', QuarterValue: 'Q4' }
  ];


  constructor(
    protected common: CommonService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private incometax: IncometaxService,
    private combo: ComboService,
    private route: ActivatedRoute,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
  }


  ngOnInit(): void {

    this.reportType = this.route.snapshot.url
      .map(segment => segment.path)
      .find(path => path === 'monthly' || path === 'quarterly') || '';

    console.log('Report Type =>', this.reportType);

    if (this.reportType === 'monthly') {

      this.Detail.SelectType = 'Monthly Provisional Report';

    } else if (this.reportType === 'quarterly') {

      this.Detail.SelectType = 'Quarterly Report';
    }

    this.ComboLoad('Branch');
    this.ESS_TaxFinancialYearSelect();
  }


  reportType: string = '';

  ESS_TaxFinancialYearSelect(): void {

    this.isDisabled = true;

    const requestData = {
      SelectType: 'S',
      ESS_TaxFinancialYearID: null,
      FinancialYearFrom: null,
      FinancialYearTo: null
    };

    console.log(
      'Financial Year API Request =>',
      requestData
    );

    this.incometax
      .ESS_TaxFinancialYearSelect(requestData)
      .subscribe({
        next: (response: any) => {

          console.log(
            'Financial Year API Response =>',
            response
          );

          if (
            response &&
            response.Table &&
            Array.isArray(response.Table)
          ) {

            this.FinancialYears = response.Table.map(
              (element: any) => {

                const startYear = new Date(
                  element.FinancialYearStart
                ).getFullYear();

                const endYear = new Date(
                  element.FinancialYearEnd
                ).getFullYear();

                return {
                  ...element,

                  FinancialYear:
                    `${startYear} - ${endYear}`,

                  FinancialYearValue:
                    `${startYear}${endYear
                      .toString()
                      .substring(2)}`
                };
              }
            );

            // Find active financial year
            const activeYear = this.FinancialYears.find(
              (x: any) =>
                x.IsActive === true ||
                x.IsActive === 1 ||
                x.IsActive === '1'
            );

            if (activeYear) {

              this.Detail.FinancialYear =
                activeYear.FinancialYearValue;

              console.log(
                'Selected Financial Year =>',
                this.Detail.FinancialYear
              );
            }

          } else {

            this.FinancialYears = [];

            console.warn(
              'Financial Year API returned no data'
            );
          }

          this.isDisabled = false;
        },

        error: (error: any) => {

          console.error(
            'Financial Year API Error =>',
            error
          );

          this.FinancialYears = [];

          this.isDisabled = false;

          this.toast.show({
            message: 'Unable to load Financial Year',
            type: toastTypeEnum.warning
          });
        }
      });
  }

  ComboLoad(
    Combotype: string,
    isChecked = false
  ): void {

    this.isDisabled = true;

    const requestData = {
      Combotype: Combotype,
      BranchId: this.Detail.BranchID
    };

    console.log(
      'Combo API Request =>',
      requestData
    );

    this.combo
      .ComboLoad(requestData)
      .subscribe({

        next: (response: any) => {

          console.log(
            'Combo API Response =>',
            response
          );

          if (
            response &&
            response.ComboLoad &&
            Array.isArray(response.ComboLoad)
          ) {

            if (Combotype === 'Branch') {

              this.Branchs =
                response.ComboLoad;
            }
          } else {

            if (Combotype === 'Branch') {
              this.Branchs = [];
            }
          }

          this.isDisabled = false;
        },

        error: (error: any) => {

          console.error(
            'Combo API Error =>',
            error
          );

          this.isDisabled = false;

          this.toast.show({
            message: 'Unable to load Branch',
            type: toastTypeEnum.warning
          });
        }
      });
  }

  private getReportPayload(): any {

    const requestData: any = {
      SelectType: this.Detail.SelectType,
      EmpType: this.Detail.EmpType || '',
      FinancialYear: this.Detail.FinancialYear || '',
      BranchID: this.Detail.BranchID || 0,
      Empcode: this.Detail.Empcode || '',
      EmpmasterID: this.Detail.EmpmasterID || 0,
      SiteIDs: this.Detail.SiteIDs || '',
      UserID: this.Detail.UserID || 0
    };

    if (this.reportType === 'monthly') {

      requestData.TaxBasedon =
        this.Detail.TaxBasedon || '';

      requestData.TaxMonth =
        this.Detail.TaxMonth || '';

      requestData.Quarter = '';

    } else if (this.reportType === 'quarterly') {

      requestData.Quarter =
        this.Detail.Quarter || '';

      requestData.TaxBasedon = '';
      requestData.TaxMonth = '';
    }

    console.log(
      'GetIncomeTaxReport Payload =>',
      requestData
    );

    return requestData;
  }


  TaxCategoryMasterSelectLoad(): void {

    const requestData =
      this.getReportPayload();

    console.log(
      'GetIncomeTaxReport Payload =>',
      requestData
    );

    this.incometax
      .GetIncomeTaxReport(requestData)
      .subscribe({

        next: (response: any) => {

          console.log(
            'GetIncomeTaxReport Response =>',
            response
          );

          if (
            response &&
            response.Table &&
            Array.isArray(response.Table) &&
            response.Table.length > 0
          ) {

            this.TableDatas =
              response.Table;

          } else {

            this.TableDatas = [];
          }
        },

        error: (error: any) => {

          console.error(
            'GetIncomeTaxReport Error =>',
            error
          );

          this.TableDatas = [];

          this.toast.show({
            message: 'Unable to load report',
            type: toastTypeEnum.warning
          });
        }
      });
  }

  excelDownload(): void {

    if(this.Detail.Quarter == null && this.reportType === 'quarterly'){
      this.toast.show({message: 'Please select quarter', type: toastTypeEnum.warning});
      return;
    }

    if (!this.Detail.FinancialYear) {

      this.toast.show({
        message: 'Please Select Financial Year',
        type: toastTypeEnum.warning
      });

      return;
    }

    // if (!this.Detail.BranchID) {

    //   this.toast.show({
    //     message: 'Please Select Branch',
    //     type: toastTypeEnum.warning
    //   });

    //   return;
    // }

    this.isDisabled = true;

    const requestData = this.getReportPayload();

    console.log(
      'Excel API Payload =>',
      JSON.stringify(requestData, null, 2)
    );

    this.incometax.GetIncomeTaxReport(requestData).subscribe({
      next: (response: any) => {

        console.log(
          'Excel API Response =>',
          response
        );

        if (
          response?.Table &&
          Array.isArray(response.Table) &&
          response.Table.length > 0
        ) {

          this.TableDatas = response.Table;

          if (this.reportType === 'monthly') {
            this.download.exportToExcelWithProgress(
              this.TableDatas,
              'MonthlyProvisionalReport',
            );
          } else if (this.reportType === 'quarterly') {
            this.download.exportToExcelWithProgress(
              this.TableDatas,
              'QuarterlyDeductionReport',
            );
          }
          this.toast.show({
            message: 'Excel generated successfully',
            type: toastTypeEnum.success
          });

        } else {

          this.TableDatas = [];

          this.toast.show({
            message: 'No Data Found',
            type: toastTypeEnum.warning
          });
        }

        this.isDisabled = false;
      },

      error: (error: any) => {

        console.error(
          'GetIncomeTaxReport Excel API Error =>',
          error
        );

        this.isDisabled = false;

        this.toast.show({
          message: 'Unable to generate Excel',
          type: toastTypeEnum.warning
        });
      }
    });
  }


  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }
}
